//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNewsData } from '~/api/index';

export default {
  data() {
    return {
      indexNews: [],
    };
  },
  async fetch() {
    const $axios = this.$nuxt.$axios;
    const data = await $axios(
      getNewsData({
        createDate: '',
        count: 6,
      })
    ).catch(() => {});
    this.indexNews = data?.result ?? [];
  },
};
